import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './Services.css';
import Banner from './Banner';
import { useNavigate } from 'react-router-dom';

const services = [
  {
    title: 'Interior Design',
    catalog: './images/alreadymadefurniture.pdf',
    description: 'Transforming your spaces with modern and timeless design.',
    image: 'https://images.unsplash.com/photo-1618219908412-a29a1bb7b86e?w=500',
    gallery: [
      './images/banner1.jpg',
      './images/inspiredliving.jpg',
      './images/insurancebanner.jpg'
    ]
  },
  {
    title: 'Customized Furniture',
    description: 'Tailor-made pieces crafted to match your style and comfort.',
    image: 'https://plus.unsplash.com/premium_photo-1661765778256-169bf5e561a6?w=500',
    catalog: './images/furniture1.pdf',
    gallery: [
      './images/luxurybed2.jpg',
      './images/unitluxury.JPG',
      './images/customtable.jpg'
    ]
  }
  // {
  //   title: 'Already Made Furniture',
  //   catalog: './images/alreadymadefurniture.pdf',
  //   description: 'Elegant ready-to-go furniture for instant sophistication.',
  //   image: 'https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=500',
  //   gallery: [
  //     './images/classybed.jpg',
  //     './images/locker.jpg',
  //     './images/saunabed.jpg'
  //   ]
  // }
];

const Services = () => {
  const [selectedService, setSelectedService] = useState(null);
  const nav =useNavigate()

  return (
    <section className="services-section">
      <Banner />
      <motion.h2
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
        className="services-title"
        onClick={()=>nav('/services')}
      >
        Our Services
      </motion.h2>

      <div className="services-grid">
        {services.map((service, index) => (
          <motion.div
            key={index}
            className="service-card"
            style={{ backgroundImage: `url(${service.image})` }}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            viewport={{ once: true }}
          >
            <div className="card-overlay">
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <button className="view-btn" onClick={() => setSelectedService(service)}>
                View Details
              </button>
            </div>
          </motion.div>
        ))}
      </div>

      {selectedService && (
        <div className="modal-overlay" onClick={() => setSelectedService(null)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <h3>{selectedService.title}</h3>
            <p>{selectedService.description}</p>
            <div className="modal-images">
              {selectedService.gallery.map((img, i) => (
                <img key={i} src={img} alt={`Gallery ${i}`} />
              ))}
            </div>
            <button className="close-btn" onClick={() => setSelectedService(null)}>Close</button>
          </div>
        </div>
      )}
    </section>
  );
};

export default Services;
